(function() {
    'use strict';
    angular.module('voyageReport')
        .service('voyageReportService', voyageReportService);

    function voyageReportService(RemoteService, CommonMasterData, VoyageReportFactory) {

    	var self = this;
        self.searchParams = {};

        self.getCachedKeywordFilter = function(){
        	if (!!self.searchParams && !!self.searchParams.keywordFilter) {
                return self.searchParams.keywordFilter;
            }
        	return null;
        }

        self.searchVoyageReport = function(param, successFn, errorFn) {
            if (!!param) {
                self.searchParams = param;
            }
            var formatedData = VoyageReportFactory.formatSearchParams(self.searchParams);
            RemoteService.searchVoyageReport(formatedData)
                .then(function(response) {
                    successFn(response);
                }, function(error) {
                    errorFn(error);
                });
        }

        self.loadDistributionList = function(successFn, errorFn) {
            RemoteService.loadDistributionList()
                .then(function(response) {
                    successFn(response);
                }, function(error) {
                    errorFn(error);
                });
        }

        self.addSaveSendVoyageDetails = function(param, successFn, errorFn) {
            RemoteService.addSaveSendVoyageDetails(param)
                .then(function(response) {
                    successFn(response);
                }, function(error) {
                    errorFn(error);
                });
        }

        self.closeVoyageEntry = function(param, successFn, errorFn) {
            RemoteService.closeVoyageEntry(param)
                .then(function(response) {
                    if (response.success) {
                        successFn(response);
                    }
                }, function(error) {
                    errorFn(error);
                });
        };

        self.openVoyageEntry = function(param, successFn, errorFn) {
            RemoteService.openVoyageEntry(param)
                .then(function(response) {
                    if (response.success) {
                        successFn(response);
                    }
                }, function(error) {
                    errorFn(error);
                });
        };

      self.loadDepartmentsList = function(successFn, errorFn) {
        RemoteService.loadVoyageRedirectingDepartmentsList()
          .then(function(response) {
            successFn(response);
          }, function(error) {
            errorFn(error);
          });
      }

    }
})();
// #
// sourceMappingURL=../../cabin-flight-admin/services/cabin-flight-admin-service.js.map
